import {ErrorLabel} from '../models/error-label.model';

export class ErrorLabelConstants {

  public static REQUIRED = new ErrorLabel(
    (control) => control.dirty && control.hasError('required'),
    'VALIDATION.REQUIRED',
    null,
  );

  public static PATTERN_INVALID = new ErrorLabel(
    (control) => control.dirty && control.hasError('pattern'),
    'VALIDATION.INVALID',
    null,
  );

  public static MAX_LENGTH = (length: number) => {
    return new ErrorLabel(
      (control) => control.dirty && control.hasError('maxlength'),
      'VALIDATION.LENGTH',
      {maxValue: length},
    );
  };

  public static MIN_LENGTH = (length: number) => {
    return new ErrorLabel(
      (control) => control.touched && control.hasError('minlength'),
      'VALIDATION.MIN_LENGTH',
      {minValue: length},
    );
  };

  public static MIN = (length: number) => {
    return new ErrorLabel(
      (control) => control.touched && control.hasError('min'),
      'VALIDATION.MIN',
      {minValue: length},
    );
  };

  public static EMAIL_INVALID = new ErrorLabel(
    (control) => control.touched && control.hasError('validateEmail'),
    'VALIDATION.EMAIL'
  );

  public static INVALID_DATE = new ErrorLabel(
    (control) => (control.dirty || control.touched) && control.hasError('is-invalid'),
    'VALIDATION.INVALID_DATE',
  );
}
